import { UseMutationOptions, UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { EnableInstance, DisableInstance } from '@pimm/services/lib/store-equipment/services';
import { DisableInstanceRequest } from '@pimm/services/lib/store-equipment';

interface MutateDisableEnableVariables extends DisableInstanceRequest {
  isEnabled?: boolean;
  siteId: string;
}

export const useMutateDisableEnable = (
  props?: UseMutationOptions<Awaited<ReturnType<typeof DisableInstance>>, unknown, MutateDisableEnableVariables>,
): UseMutationResult<unknown, unknown, MutateDisableEnableVariables> & { is503Error: boolean } => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    ({ isEnabled, siteId, ...params }: MutateDisableEnableVariables) =>
      isEnabled ? DisableInstance(siteId, params) : EnableInstance(siteId, params),
    {
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries(['GetDisplayGroups', variables.siteId]);
        if (props?.onSuccess) props.onSuccess(data, variables, context);
      },
      onError: (error, variables, context) => {
        console.error('Error toggling sensor status:', error);

        // Execute the user-provided onError callback if it exists
        if (props?.onError) {
          props.onError(error, variables, context);
        }
      },
    },
  );

  return {
    ...mutation,
    is503Error: mutation.isError && (mutation.error as any)?.response?.status === 503,
  } as UseMutationResult<unknown, unknown, MutateDisableEnableVariables> & { is503Error: boolean };
};
